export default __webpack_public_path__ + "static/media/5-sgi-home-v2.58714ea0.png";